'use client';

import type { ComponentProps, ReactNode } from 'react';
import { Box, HStack } from '@terra/ui-styled-system';
import { BodyDefault, MetaDefault } from '../../components/typography';
import type { GroupHeaderRowBase } from './group-rows';
import { GroupToggleButton } from './GroupToggleButton';

export type GroupHeaderCellProps = {
  group: Pick<GroupHeaderRowBase, 'groupKey' | 'groupLabel' | 'count'>;
  isCollapsed: boolean;
  onToggle: (groupKey: string) => void;
  containerProps?: ComponentProps<typeof Box>;
  icon?: ReactNode;
  showToggle?: boolean;
};

export function GroupHeaderCell({
  group,
  isCollapsed,
  onToggle,
  containerProps,
  icon,
  showToggle = true,
}: GroupHeaderCellProps) {
  return (
    <Box
      w="full"
      h="full"
      display="flex"
      alignItems="center"
      cursor="pointer"
      {...containerProps}
      onClick={(event) => {
        containerProps?.onClick?.(event);
        onToggle(group.groupKey);
      }}
    >
      <HStack gap="2" alignItems="center" minW={0} w="full">
        {showToggle ? (
          <GroupToggleButton
            groupKey={group.groupKey}
            isCollapsed={isCollapsed}
            onToggle={onToggle}
          />
        ) : null}
        {icon ? (
          <Box flexShrink={0} display="inline-flex" color="fg.muted">
            {icon}
          </Box>
        ) : null}
        <HStack gap="1.5" alignItems="center" minW={0}>
          <BodyDefault color="fg.neutral.default" truncate>
            {group.groupLabel}
          </BodyDefault>
          <MetaDefault color="fg.neutral.subtle" flexShrink={0}>
            {group.count}
          </MetaDefault>
        </HStack>
      </HStack>
    </Box>
  );
}
